import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, map, startWith, takeUntil } from 'rxjs/operators';
import {
  FuelSourceType,
  paymentTypes,
} from 'src/app/shared/flight-log-api/flight-logs/flight-log-client.model';
import { getValidationErrorsChangesDeep } from 'src/util/angular/ng-forms-validation';
import { humanize } from 'src/util/text';

@Component({
  selector: 'fl-fuel-event',
  templateUrl: './fuel-event.component.html',
  styleUrls: ['./fuel-event.component.scss'],
})
export class FuelEventComponent implements OnInit, OnDestroy {
  @Input()
  public fuelEvent: UntypedFormGroup;

  public componentIsDestroyed$ = new Subject();
  public fuelSourceType$: Observable<FuelSourceType>;
  public isAmghBulk$: Observable<boolean>;
  public isFbo$: Observable<boolean>;
  public validationErrors$: Observable<string[]>;

  public paymentOptions = paymentTypes.map((paymentType) => ({
    value: paymentType,
    label: humanize(paymentType),
  }));

  constructor() {}

  public ngOnInit() {
    this.fuelSourceType$ = this.fuelSourceType.valueChanges.pipe(
      distinctUntilChanged(),
      startWith(this.fuelSourceType.value),
    );
    this.isAmghBulk$ = this.fuelSourceType$.pipe(map((_) => _ === 'AmghBulk'));
    this.isFbo$ = this.fuelSourceType$.pipe(map((_) => _ === 'Fbo'));
    this.validationErrors$ = getValidationErrorsChangesDeep(this.fuelEvent);

    this.fuelSourceType$.pipe(takeUntil(this.componentIsDestroyed$)).subscribe((fuelSourceType) => {
      if (fuelSourceType === 'AmghBulk') {
        this.fboId.setValue(null);
      } else {
        this.fuelTankId.setValue(null);
      }
    });
  }

  get fuelTankId() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.fuelEvent.get('fuelTankId')!;
  }

  get fboId() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.fuelEvent.get('fboId')!;
  }

  get fuelSourceType() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.fuelEvent.get('fuelSourceType')!;
  }

  public ngOnDestroy(): void {
    this.componentIsDestroyed$.complete();
  }
}
